<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title>
        <router-link
          class="text-decoration--none"
          :to="{ name: 'training.blogs' }"
        >
          Student Leader Training Blogs
        </router-link>
        <template v-if="blog">
          <v-icon> {{ icons.arrow }} </v-icon>
          <span>{{ blog.title }}</span>
        </template>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <div class="ma-4">
      <blog-form
        ref="form"
        :blog="blog"
        @save="saveBlog"
        :isLoading="loading"
      />
    </div>
    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { mdiChevronRight } from '@mdi/js'
import BlogForm from '@/components/BlogForm'
import Blog from '@/models/Blog'
import { each } from 'lodash'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import * as BlogType from '@/utils/consts/BlogType'

export default {
  name: 'EditTrainingBlog',

  components: {
    BlogForm,
    AppBarNavIcon
  },

  data() {
    return {
      icons: {
        arrow: mdiChevronRight
      },
      loading: false,
      blog: null
    }
  },

  mounted() {
    this.getBlog()
  },

  methods: {
    getBlog() {
      Blog.where('type', BlogType.TRAINING)
        .$find(this.$route.params.id)
        .then(blog => {
          this.blog = blog
        })
        .catch(() => {
          this.$router.replace({ name: 'training.blogs' })
        })
    },

    saveBlog(blog) {
      this.loading = true
      const formData = new FormData()
      formData.append('_method', 'PUT')
      each(blog, (value, key) => {
        if (value !== null) {
          formData.append(key, value)
        }
      })

      this.$api
        .post(`/blogs/${blog.id}`, formData)
        .then(response => {
          this.$toast('Blog successfully updated!', {
            color: 'green'
          })
          this.$router.replace({ name: 'training.blogs' })
        })
        .catch(({ response }) => {
          if (response.data && response.data.errors) {
            this.$refs.form.setErrors(response.data.errors)
          }
        })
        .then(() => {
          this.loading = false
        })
    }
  }
}
</script>
